import React, { useContext } from 'react';
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { setAvailableaccessories } from '../actions/actionsAppTest';
import { fetchSimulationAccessoriesIfNeeded } from '../actions/actionsApiSimulation';
import TestAccessories from '../components/testCriteria/TestAccessories';

export default function ContTestAccessoriesAvailable() {
  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onChangeAccessories(accessories) {
    dispatch(setAvailableaccessories(accessories));
    fetchSimulationAccessoriesIfNeeded(globalstate, dispatch, {}, accessories, null, false);
  }


  return (
    <TestAccessories
      data={globalstate.testCriteria.availableAccessories}
      settings={globalstate.settings}
      onChangeAccessories={onChangeAccessories}
    />);
}
